<app-kpi-widget
  [title]="'fuelConsumption.widgets.totalDistanceTravelled' | transloco"
  [icon]="icon"
  [isLoading]="isLoading"
  [totalValue]="value"
  [percentageDifference]="distancePercentageChange"
  [costDifference]="difference"
  [widgetDisabled]="widgetDisabled"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [valueFormatter]="formatValue.bind(this)"
  [isUptrendPositive]="true"
  [dropdownEnabled]="false"
  [hasFooter]="false">
</app-kpi-widget>